import { Response } from '@marketplace-web/shared/api-client'

import { DefaultShippingAddressResp } from 'types/api/response/default-shipping-address-resp'

import { transformAddress } from 'data/transformers/address'

export const transformDefaultShippingAddress = ({
  user_address,
}: Response<DefaultShippingAddressResp>) => {
  if (!user_address) return null

  return transformAddress(user_address)
}
